import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable,BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RendezVous } from 'model/rendezvous';
import { Employer } from 'model/model.employer';
import { Conjoint } from 'model/model.conjoint';
import { Addrembrs } from 'model/model.addrembrs';
import { Agent_Mef } from 'model/modal-cms/aget_mef';
import { Personnel } from 'model/modal-cms/personnel';
import { User } from 'model/modal-cms/user';
import { Mot_defil } from 'model/modal-cms/mot_defil';
import { UserCMS } from 'model/modal-cms/user.cms';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  httpOptions: any = {
    headers: new HttpHeaders({
       'Content-Type': 'application/json',
       'Cookie': 'JSESSIONID=B369491889B2312DD2DD5E4F55A81D7E',
       'access-control-allow-credentials' : 'true'
    })
}
  urlServer = environment.urlServer;
   urlServer3 = environment.urlServer3;
   urlServer_cms = environment.urlServer1;
   
  public newCribSubect = new Subject<any>();
  public newCribSubect2 = new Subject<any>();
  public newCribSubect_Inscrit = new Subject<any>();
  public newCribSubect_login_user_cms = new Subject<any>();
  public newCribSubect_evolution_epidemie = new Subject<any>();
   public newCribSubect_defaul_video = new Subject<any>();
   public newCribSubect_mtp_user_cms = new Subject<any>();
   public newCribSubect_message_user = new Subject<any>();
   public newCribSubect_message_bc = new Subject<any>();

   
   
   
  private photoAgent  : any;
 // headers = new HttpHeaders().set('Content-Type', 'application/json');

  private headers= new Headers({'Content-Type':'application/json', 'Access-Control-Allow-Origin' : 'http://url-serv/'});
  private options = new RequestOptions({headers:this.headers});


  userIdActuel: number;
  lieuIdActuel: any;
  userIdIscritActuel: any;
  agent_Mef : Agent_Mef;
  IMUserIscritActuel: any;
  nom_agent: any;
  Id_agent_IscritActuel: any;
  LoginUserIscritActuel: any;
  MdpUserIscritActuel:any;

  //update tiantsoa
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  evolution_epidemie_actuel: any;
  hafatrynyfilofa_actuel: any;
  default_video_actuel: any;
  date_deb_visiteur: any;

  constructor(public http: Http) { 

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }




  

  // getListeQuestion() {
  //   return this.http.get(this.urlServer+"Question");
  // }

  getListeQuestion() {
    return this.http.get(this.urlServer +"Question")
      .map(resp => resp.json());
  }

  getnombrevisiteur() {
    return this.http.get(this.urlServer_cms +"Utilisateur/getCount")
      .map(resp => resp.json());
  }

  



  getnombreQuestionEnAttante(etat_mes:any) {
    return this.http.get(this.urlServer_cms +"Question/getCount/"+etat_mes)
      .map(resp => resp.json());
  }

  getnombreQuestionEnAttanteByUser(etat_mes:any,id_dest:any) {
    return this.http.get(this.urlServer_cms +"Question/getCountbyAgent/"+etat_mes+"/"+id_dest)
      .map(resp => resp.json());
  }

  //BC
  getnombreBCEnAttanteByDirection(dir:any,etat_bc:any) {
    return this.http.get(this.urlServer_cms +"Bc/getCount/"+dir +"/"+etat_bc)
      .map(resp => resp.json());
  }


  //gerer mot defil

  getmot_defil() {
    return this.http.get(this.urlServer_cms +"Question/get_mot_defil" )
      .map(resp => resp.json());
  } 

  getmot_defil_by_etat(a: any) {
    return this.http.get(this.urlServer_cms +"Question/find_mot_defil_etat/" + a)
      .map(resp => resp.json());
  }

  getmot_defil_by_id(a: any) {
    return this.http.get(this.urlServer_cms +"Question/find_mot_defil/" + a)
      .map(resp => resp.json());
  }


 saveMot_defil(mot_defil: Mot_defil): Observable<any> {
   let headers = new Headers();
   headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
   let body = JSON.stringify(mot_defil);
   let options = new RequestOptions({ headers: headers });
   return this.http.post(this.urlServer_cms + "MotDefilCreate", body, options);
 }

 updateMot_defil(mot_defil: Mot_defil): Observable<any> {
  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  let body = JSON.stringify(mot_defil);
  let options = new RequestOptions({ headers: headers });
  return this.http.post(this.urlServer_cms+"Question/update_mot_defil_etat/"+ mot_defil.id_mot, body, options);  
}

deleteMot(id_rap:number): Observable<any> {
  return this.http.delete(this.urlServer_cms + "Question/delete_mot_defil_etat/"+id_rap)
    .map(resp => resp.json());
}

  

  

  setUserIscrit(id_iscrit: any,im_iscrit: any) {
    this.userIdIscritActuel = id_iscrit;
    this.IMUserIscritActuel = im_iscrit;
    
    console.log(this.userIdIscritActuel, this.IMUserIscritActuel )
    this.newCribSubect_Inscrit.next(this.userIdIscritActuel);
  }

  setUserIscrit_id(id_agent_iscrit: any){
    this.Id_agent_IscritActuel = id_agent_iscrit;
  }

  setMessage_User(message_agent: any){
    this.newCribSubect_message_user.next(message_agent);
  }

  setMessage_BC(message_bc: any){
    this.newCribSubect_message_bc.next(message_bc);
  }


  setUserloginUserCMS(login_user_cms:any, mdp:any){
   //// let user:User;
   // user.login_user=login_user_cms;
   // user.mot_de_pass=mdp
    this.LoginUserIscritActuel = login_user_cms;
    this.MdpUserIscritActuel = mdp;
    this.newCribSubect_login_user_cms.next(this.LoginUserIscritActuel );
    this.newCribSubect_mtp_user_cms.next( this.MdpUserIscritActuel)
    }

  setEvolutionEpidemi(evolution_epidemie: any,hafatra:any){
    this.evolution_epidemie_actuel= evolution_epidemie;
    this.hafatrynyfilofa_actuel= hafatra;
    this.newCribSubect_evolution_epidemie.next(this.evolution_epidemie_actuel);
  }



  setDefaultVideo(default_video: any){
    this.default_video_actuel = default_video;
    this.newCribSubect_defaul_video.next(this.default_video_actuel);
  }

  setDateDebVisiteur(date_deb: any){
    this.date_deb_visiteur = date_deb;

  }

  getdate_deb_visiteur(){
    return  this.date_deb_visiteur;
  }

  getevolution_default_video(){
    return  this.default_video_actuel;
  }

  getevolution_epidemie_actuel(){
    return  this.evolution_epidemie_actuel;
  }

  getehafatrynyfilofa_actuel(){
    return  this.hafatrynyfilofa_actuel;
  }

  

  getUserIdIscrit(){
    return this.Id_agent_IscritActuel;
  }


  getUserIscrit(){
    return this.userIdIscritActuel;
  }

  getUserIMIscrit(){
    return this.IMUserIscritActuel;
  }


  getLoginUseCMS(){
    return this.LoginUserIscritActuel;
  }



   getMtpUseCMS(){
    return this.MdpUserIscritActuel;
  }


  //get agent site cms
    //MAKA NY INFORMATION MOMBA ILAY USER CONNECTE
    getUserCMSConnected(a: any, b: any) {
       return this.http.get(this.urlServer_cms +"Users/find_by_type/" + a + "/" + b)
         .map(resp => resp.json());
     }
   

   

    saveUserConnected(agent_Mef: Agent_Mef): Observable<any> {
      let headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      let body = JSON.stringify(agent_Mef);
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.urlServer_cms + "VisiteurCreate", body, options);
    }
   

  //get agent ROHY

  //http://rohi.mfb.gov.mg:8088/ROHI/service/checkAgent?login=spoot&password=0408&zHashCode=ABCDEFghojklm123456789

  sendloginWSRohy(log:any,motpass:any,code:string) {
    return this.http.get("http://rohi.mfb.gov.mg:8088/ROHI/service/checkAgent?login="+log+"&password="+motpass+"&zHashCode="+code)
     .map(resp => resp.json());
 }


 //http://rohi.mfb.gov.mg:8088/ROHI/service/agent?q=203 131 007 842&zHashCode=ABCDEFghojklm123456789
  getlisteWSDrh2(event:any,code:string) {
    return this.http.get("http://rohi.mfb.gov.mg:8088/ROHI/service/agent?q="+event+"&zHashCode="+code)
     .map(resp => resp.json());
 }

 //update compte user  ()
 updateUser(userCMS: UserCMS,code:string): Observable<any> {
  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  let body = JSON.stringify(userCMS);
  let options = new RequestOptions({ headers: headers });
  return this.http.post("http://rohi.mfb.gov.mg:8088/ROHI/service/updateCompteAgent/"
  +userCMS.id_user+"&zHashCode="+code,body, options)
 // return this.http.post(this.urlServer+"Users/update/"+utilisateur.id_user, body, options);
}

 


  setConnectedEmployer(e:Agent_Mef){
    console.log(".................agent mef transfere .............."+e )
    this.newCribSubect2.next(e);
    console.log("..............this.newCribSubect2.next(this.agent_Mef.agent_nom);..............."+e)

  }

  setConnectedEmployer_old(e:Agent_Mef){
    console.log("agent mef transfere"+e )
    this.agent_Mef=e;
    this.nom_agent = e.agent_nom
    this.newCribSubect.next(this.agent_Mef);
    this.newCribSubect2.next(this.agent_Mef.agent_nom);
    console.log("this.newCribSubect2.next(this.agent_Mef.agent_nom);"+this.agent_Mef.agent_nom )

  }

  getConnectedEmployer(){
    return this.agent_Mef;
  }

  getConnectedEmployernom(){
    return this.nom_agent;
  }




  
  setUserId(id: number) {
    this.userIdActuel = id;
    console.log(this.userIdActuel)
    //this.newCribSubect.next(this.userIdActuel);
  }


  getListeAttenteParMed(){
    return this.http.get(this.urlServer3+"ws/statistique_medecin")
    .map(resp => resp.json());
  }

  getListeAttenteParMedParIM(mcl:any){
    return this.http.get(this.urlServer3+"ws/statistique_medecin?mc="+mcl)
    .map(resp => resp.json());
  }

  getListeAttenteParMedParMLocalite(mcl:any){
    return this.http.get(this.urlServer3+"ws/statistique_medecin?lc="+mcl)
    .map(resp => resp.json());
  }


  setlieu(id: any) {
    this.lieuIdActuel = id;
    console.log("tafa" + this.lieuIdActuel)
    this.newCribSubect2.next(this.lieuIdActuel);
  }


//get Famille

 getlisteFamille(id_agent:any) {
    return this.http.get(this.urlServer3+"ws/agent_et_famille?im="+id_agent)
      .map(resp => resp.json());
  }

  getAlllisteFamille(id_agent:any) {
    return this.http.get(this.urlServer3+"/chercherConjoint_et_Enfant_agent?id="+id_agent)
      .map(resp => resp.json());
  }


  

  //Web service


  //rdv en ligne by agent

  /// http://10.2.250.161:7001/cms/ws/rendez_ligne_agent?id=TSZ 

  getListeRDVParAgent(id_agent:number) {
    return this.http.get(this.urlServer3+"ws/rendez_vous_ligne_agent?id="+id_agent)
      .map(resp => resp.json());
  }

  //rendez_vous.  
  //get list of rdv by Dr (liste  rdv en attente accueil)  http://10.2.250.161:7001/cms/ws/rendez_vous_medecin?id=70
  getListeRDVParDr(id_dr:number) {
    return this.http.get(this.urlServer3+"ws/rendez_vous_medecin?id="+id_dr)
      .map(resp => resp.json());
  }


  getInfoMedByIM(id_dr:number){
    return this.http.get(this.urlServer3+"ws/statistique_medecin?id="+id_dr)
    .map(resp => resp.json());
  }


  //save of rdv on line
  saveRendezVous(r: RendezVous) {
    return this.http.post(this.urlServer3 + "ws/post_rdv", r)
      .map(resp => resp.json());
  }


  //Historique consultation par agent
 
   getConsultationParConjoint(id: number) {
    return this.http.get(this.urlServer+"chercherConsultatitonParConjoint/"+id+"?e=A")
      .map(resp => resp.json());
  }


  



  //get consultation par medecin
  getConsultationParMedecin(id: number,mc: String,size : number , page : number) {
    return this.http.get(this.urlServer+"chercherConsultatitonParMedecin/"+id+"?e=A&mc="+mc+"&size="+size+"&page="+page)
      .map(resp => resp.json());
  }



  //Détail consultation patient
  getConsultationById(id: number) {
    return this.http.get(this.urlServer + "/consultation/" + id)
      .map(resp => resp.json());
  }


  //get categorie med
  getCategories(){
    return this.http.get(this.urlServer+"/cat",this.options)
    .map((response)=>response.json())   
  }

  // liste patient donner ordonnance  
  getlistePatientDonnerOrdonnance() {
    return this.http.get(this.urlServer + "/ordonnance")
      .map(resp => resp.json());
  }

  // liste patient avoir des repos par le médcin 
  getlistePatientGagneRepos() {
    return this.http.get(this.urlServer + "/repos")
      .map(resp => resp.json());
  }


  //statistique
      //nbr consultation medecin
  getStatistiqueConsultationParMedecin( emp: Employer){
    return this.http.post(this.urlServer+"/consultation/statistique/medecin",emp)
          .map(resp => resp.json());
    }

              // get list medecin
    getMedecin(pc: String, page: number, size: number) {
      return this.http.get(this.urlServer+"chercherMedecin?pc="+pc+"&size="+size+"&page="+page)
        .map(resp => resp.json());
    }


    //get localite
    getLibelleLocalite(id){
      if(!id) return "";
      if(id=='ANT') return "ANTANINARENINA";
      if(id=='MDC') return "ANTANINARENINA";
      if(id=='TSZ') return "TSIAZOTAFO";
      if(id=='AEP') return "ANOSY";
    
    }



//nbr consultation par agent
    //get info agent
    getStatistiqueConsultationParAgent( c: Conjoint){
      return this.http.post(this.urlServer+"/consultation/statistique/agent",c)
            .map(resp => resp.json());
      }

       // //recuperer les donnée au champ
  getConjoinsParIm(im: String) {
    return this.http.get(this.urlServer+"conjoint/im/"+im)
      .map(resp => resp.json());
  }

  
getStatistiquePrescriptionParAgent( c: Conjoint){
  return this.http.post(this.urlServer+"/prescription/statistique/agent",c)
        .map(resp => resp.json());
  }



//remboursement
  //statut de dossier
  getListRembourseGeneral(motCle: String, page: number, size: number){
    return this.http.get(this.urlServer+"ChercherGeneral?mc=" + motCle+ "&size=" + size + "&page=" + page )
   .map(resp => resp.json());
    }

//get libele statut des dossier

    getLibelleEtatDossier(code : String){
      if(!code)return null;
      if(code ==="E")return "Enregistré";
      if(code ==="RJ")return "Rejeté juridique";
      if(code ==="RJCHF")return "Rejeté juridique(chef)";
      if(code ==="RJARV")return "Rejeté Juridique à revoir";
      if(code ==="J")return "validé Juridique";
      if(code ==="A" || code=="AAPR")return "Administratif";
      if(code ==="M" || code=="MAPR")return "Medicale";
      if(code ==="V" || code=="VAPR")return "Validé CHEF CMS";
      if(code ==="R" || code=="RAPR")return "Rejeté CHEF CMS";
      if(code ==="RARV")return "Rejeté à revoir";
      if(code ==="P")return "Valider Preparateur";
      if(code ==="RP")return "Rejeté Preparateur";
      if(code ==="ORD")return "Ordonnancé";
      if(code ==="RORD")return "Rejeté Ordonnancement";
      if(code ==="ENG")return "Engagé";
      if(code ==="RE")return "Rejeté Engagement";
      else return null;
    }


    // get getStatistiqueRemboursementParAgent
    getStatistiqueRemboursementParAgent( c: Conjoint){
      return this.http.post(this.urlServer+"/enregistrer/statistique/agent",c)
            .map(resp => resp.json());
      }

          /****statistique remboursement total par type*****/
    getStatistiqueRemboursementTotal( e: Addrembrs){
      return this.http.post(this.urlServer+"/enregistrer/statistique/total",e)
            .map(resp => resp.json());
      }

      //get libele type remboursement
      getLibelleTypeRembourse(code : String){
        if(!code)return null;
        if(code ==="LUN")return "Lunetterie";
        if(code ==="HSP")return "Hospitalisation";
        if(code ==="MDC")return "Frais médicaux";
        if(code ==="BLB")return "Bilan Biologiques";
        if(code ==="IMG")return "Imagerie Medicale";
        if(code ==="COM")return "Frais communs";
        else return null;
      }

//Agent et famille
   //rechercher Agent
  getListeAgent_etFamille(motCle: String, page: number, size: number) {
    return this.http.get(this.urlServer+"chercherTous?mc="+motCle+ "&size="+size+"&page="+page)
      .map(resp => resp.json());
  }


  getListeAgent(motCle: String, page: number, size: number) {
   //modif

    //fin modif
   return this.http.get(this.urlServer+"chercherAgent?mc="+motCle+ "&size="+size+"&page="+page,this.httpOptions.headers )
     .map(resp => resp.json());
 }

 //get enfant
 getEnfant(id: number) {
  return this.http.get(this.urlServer+"conjoint/" + id)
    .map(resp => resp.json());
}


recupererAgentConjoint(id : number,type: string) {
  return this.http.get(this.urlServer+"chercherConjoint_agent?id="+id+"&type="+type)
     .map(resp => resp.json());
 }

 //rechercher Enfant by Nathan
 getListeEnfantAgent(id: number) {
  return this.http.get(this.urlServer+"chercherEnfant_agent?id="+id)
    .map(resp => resp.json());
}

//get photo
getUrlImageFromServer(conjoint : Conjoint) {
  var url_photo=conjoint.agent_url_photo;
  this.newCribSubect.next(url_photo);
    if(!url_photo || url_photo.length==0)return "";
       if(url_photo.indexOf(".")==0) return this.urlServer+"conjoint/images?id="+conjoint.id;
       else return url_photo;
      
    }

    getUserId(){
      return this.photoAgent;
    }

    

    getAgendaByEmployer(id :number,motCle: String, page: number, size: number) {
      return this.http.get(this.urlServer+"chercherAgendaByEmployer?mc="+motCle+"&size="+size+"&page="+page+"&id="+id)
        .map(resp => resp.json());
    }

//get repos agent  http://10.2.250.161:7001/cms/ws/repos?im=372391
getListeReposAgent(im_agent:any){
 return this.http.get(this.urlServer3+"ws/repos?im="+im_agent)
        .map(resp => resp.json());
}

    //get dep
    getListeDepartement(motCle: String, page: number, size: number) {
      return this.http.get(this.urlServer+"chercherDepartements?mc="+motCle+ "&size="+size+"&page="+page)
        .map(resp => resp.json());
    }
  
       getListeDirection(departementId: String, page: number, size: number) {
      return this.http.get(this.urlServer+"chercherDirections?dep_id="+departementId+ "&size="+size+"&page="+page)
        .map(resp => resp.json());
    }
  
      getListeService(departementId: String,directionId: String, page: number, size: number) {
      return this.http.get(this.urlServer+"chercherServices?dep_id="+departementId+"&dir_id="+directionId+ "&size="+size+"&page="+page)
        .map(resp => resp.json());
    }


    getStockClientPharmacieByMcLc(mc:String,pc:String,lc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherStock_petit_clientPharmacieLc?pc=" +pc+ "&page=" +size+ "&size=" +page+"&mc="+mc+'&lc='+lc)
      .map(resp => resp.json());
    }

    getListMedicaments(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicament/MED?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }

    getListConsDentisterie(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicament/DENT?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }

    getListConsSoin(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicament/SOI?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }  

    getListConsEC(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicament/EC?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }  


    getListConsLab(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicament/LAB?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }  


    getConsBymotCle(mc:String, size:number, page:number){
      return this.http.get(this.urlServer+"/chercherMedicamentCons?motCle=" +mc+ "&size=" +size+ "&page=" +page)
      .map(resp => resp.json());
    }


    getLibelleType(libelle_code){
      if(!libelle_code)return "VIDE";
     // if(libelle_code=="")
      if(libelle_code=="SCN") return "Scanner";
      if(libelle_code=="LAB") return "Laboratoire";
      if(libelle_code=="ECH") return "Echographie";
      if(libelle_code=="RAD") return "Radiographie";
      return libelle_code;
    }


    getLibelleTypeMedeci(libelle_code){
      if(!libelle_code)return "VIDE";
     // if(libelle_code=="")
      if(libelle_code=="MDC") return "Géneraliste";
      if(libelle_code=="ASTP") return "Assistante pédiatre";
      if(libelle_code=="DST") return "Dentiste";
      if(libelle_code=="PED") return "Pédiatre";
      if(libelle_code=="OPH") return "Ophtalmologie";
      if(libelle_code=="GYN") return "Gynécologue";
      if(libelle_code=="NEU") return "Neuro-psychiatre";
      return libelle_code;
    }

    //retur etet message 
    getEtatRDV(libelle_etat){
      if(!libelle_etat) return "VIDE";
       if(libelle_etat=="L") return "Créer";
      if(libelle_etat=="R") return "Rejeter";
      if(libelle_etat=="V") return "Valider";

    }

}
